import { API } from "../Config/API";

const GET = async (url: any, params: any = {}) => {
  return new Promise(async (resolve, reject) => {
    // Build query string from params
    const queryString = Object.keys(params)
      .filter(
        (key) =>
          params[key] !== null &&
          params[key] !== undefined &&
          params[key] !== ""
      )
      .map(
        (key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join("&");

    const fullUrl = `${API.BASE_URL}${url}${
      queryString ? `?${queryString}` : ""
    }`;

    fetch(fullUrl, {
      method: "get",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const POST = async (url: any, body: any) => {
  return new Promise(async (resolve, reject) => {
    fetch(API.BASE_URL + url, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((json) => {
        resolve(json);
      })
      .catch((error) => {
        reject(error);
      });
  });
};

const UPLOADTOS3 = async (file: any, filename: any) => {
  const fileLabel = filename?.replace(/\s+/g, "_");
  // Convert base64 data URL to Blob
  const arr = file.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
  const bstr = atob(arr[1]);
  let n = bstr.length;
  const u8arr = new Uint8Array(n);
  while (n--) u8arr[n] = bstr.charCodeAt(n);
  const blob = new Blob([u8arr], { type: mime });

  const formData = new FormData();
  formData.append("image", blob, fileLabel + ".png");

  const response = await fetch(API.UPLOAD_URL, {
    method: "POST",
    body: formData,
  });
  const data = await response.json();
  return { Location: data.imageUrl };
};

export { GET, POST, UPLOADTOS3 };
